<script>
import Drawer from "@/components/drawer";

// Custom Components
import PageHeader from "@/components/page-header";
import GuestFrom from "@/components/guestForm/GuestForm";
import CardDetails from "@/components/guestForm/CardDetails.vue";
import MemberShipCardDetail from "@/components/guestForm/MemberShipCard";
import errorHandler from "@/helpers/errorHandler";
import GuestService from "@/helpers/APIService/guest.service";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

const initGuest = {
  name: "",
  email: "",
  mobile: "",
  date_of_birth: "",
  gender: "",
  selfie_image: "",
  address_line_first: "",
  address_line_second: "",
  city: "",
  state: "",
  country: "",
  zip_code: "",
  doc_type: "",
  doc_number: "",
  doc_image: "",
  doc_issue_date: "",
  doc_expire_date: "",
  doc_issued_by: "",
  doc_is_verify_by_hotel: false,
};

export default {
  page: {
    title: "Guest",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    CardDetails,
    MemberShipCardDetail,
    PageHeader,
    GuestFrom,
  },
  data() {
    return {
      title: "Guest",
      cardGuestObj: {},
      guest: {},
      guestId: "",
      isEdit: false,
      isBtnLoading: false,
      openNewGuestForm: false,
      submitted: false,
      cardViewModalOpen: false,
      memberShipCardOpen: false,
      filter: { name: "", email: "", mobile: "" },
      table: {
        tableData: [],
        size: 100,
        next: null,
        previous: null,
      },
      isDataLoading: false,
      viewFilter: false,
    };
  },
  computed: {
    ...authComputed,
    rows() {
      return this.table.tableData.length;
    },
    guestProps() {
      return {
        guestId: this.guestId,
        isEdit: this.isEdit,
        guest: this.guest,
      };
    },
    cardProps() {
      return {
        guest_id: this.cardGuestObj,
      };
    },
  },
  mounted() {
    this.getGuestListData("");
  },
  methods: {
    // Method is use for get all guest list
    getGuestListData(query, status) {
      this.isDataLoading = true;
      let dataToBeFilter = "";
      if (query !== undefined) {
        dataToBeFilter = query;
      }
      GuestService.getGuestList(dataToBeFilter)
        .then((response) => {
          response.results.map((guest) => {
            let name = "";
            if (guest.last_name !== null) {
              name = guest.last_name;
            }
            if (guest.first_name !== null) {
              name = name + " " + guest.first_name;
            }
            guest = { ...guest, name };
            this.table.tableData.push(guest);
          });
          this.table.previous = response.previous;
          this.table.next = response.next;
          this.isDataLoading = false;
          this.isBtnLoading = false;
          this.busy = false;
          if (status == "load_more") {
            setTimeout(() => {
              this.$refs.scrollTo.click();
            }, 500);
          }
        })
        .catch((error) => {
          this.isBtnLoading = false;
          errorHandler(error);
        });
    },
    // Method is used to get more guest
    loadMore: function () {
      if (this.table.next !== null) {
        const str = this.table.next.split("?");
        this.getGuestListData(`?${str[1]}`, "load_more");
      }
    },
    // Method is use for open filter drawer
    async openGuestFilter() {
      this.viewFilter = !this.viewFilter;
    },
    // Method is use for reset filter
    filterReset() {
      this.filter = {
        name: "",
        email: "",
        mobile: "",
      };
      this.getGuestListData();
    },
    // Method is use for filter data
    async filterData() {
      this.isBtnLoading = true;
      this.getGuestListData();
    },
    // Method is use update and add new guest in guest list table
    handleSubmit(data, guestId, isEdit) {
      if (isEdit) {
        const index = this.table.tableData.findIndex(
          (obj) => obj.id == guestId
        );
        let name = "";
        if (data.first_name !== null) {
          name = data.first_name;
        }
        if (data.last_name !== null) {
          name = name + " " + data.last_name;
        }
        data = { ...data, name };
        this.table.tableData[index] = data;
        this.newGuestForm();
      } else {
        let name = "";
        if (data.first_name !== null) {
          name = data.first_name;
        }
        if (data.last_name !== null) {
          name = name + " " + data.last_name;
        }
        data = { ...data, name };
        this.table.tableData.push(data);
        this.newGuestForm();
      }
    },
    // Method is use for save and add new guest continues
    saveAndAddNewGuest(data) {
      let name = "";
      if (data.first_name !== null) {
        name = data.first_name;
      }
      if (data.last_name !== null) {
        name = name + " " + data.last_name;
      }
      data = { ...data, name };
      this.table.tableData.push(data);
      this.guest = initGuest;
    },
    // Method is use for update guest details
    editGuest(data) {
      this.isEdit = true;
      this.guest = data;
      this.guestId = data.id;
      this.newGuestForm();
    },
    // Method is use for open and close guest form
    newGuestForm() {
      if (this.openNewGuestForm === true) {
        this.isEdit = false;
        this.guest = initGuest;
      }
      this.openNewGuestForm = !this.openNewGuestForm;
    },
    // method is use to maintained card modal
    cardViewModal(id, name) {
      this.guestId = id;
      this.cardGuestObj = { id, name };
      this.cardViewModalOpen = !this.cardViewModalOpen;
    },
    // Method is use for close add new card modal
    cardModal() {
      this.cardViewModalOpen = !this.cardViewModalOpen;
    },
    memberShipCard() {
      this.memberShipCardOpen = !this.memberShipCardOpen;
    },
    // Method is use for maintained guest avatar
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },
    // Method is use for update guest premium status
    changePremiumStatus(guest_id, data) {
      GuestService.editGuest(data, guest_id)
        .then(() => {
          Middleware.notification("Guest is premium now !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    //Method is use for update guest block status
    changeBlockStatus(guest_id, data) {
      GuestService.editGuest(data, guest_id)
        .then(() => {
          if (data.is_add_blacklist) {
            Middleware.notification("Guest is blocked !!", "danger");
          } else {
            Middleware.notification("Guest is unblocked !!", "success");
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    //Method is to create wake-up call
    createWakeUp(data) {
      console.log(data);
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="newGuestForm"
      text="Add New Guest"
      :isButton="true"
    />
    <div
      class="row"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="isDataLoading"
      infinite-scroll-distance="100"
    >
      <a
        href="#"
        v-scroll-to="{
          element: `#guest${table.tableData.length - 25}`,
          offset: 500,
        }"
        ref="scrollTo"
        class="d-none"
        >Scroll</a
      >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <v-table
                    :data="table.tableData"
                    class="table table-hover mb-0"
                    ref="my-table"
                  >
                    <thead class="table-light" slot="head">
                      <tr>
                        <v-th sortKey="first_name">
                          Name
                          <i
                            class="fas fa-search text-end float-end mt-1"
                            @click="openGuestFilter"
                          ></i>
                        </v-th>
                        <v-th sortKey="email">
                          Email
                          <i
                            class="fas fa-search text-end float-end mt-1"
                            @click="openGuestFilter"
                          ></i>
                        </v-th>
                        <v-th sortKey="mobile">
                          Mobile
                          <i
                            class="fas fa-search text-end float-end mt-1"
                            @click="openGuestFilter"
                          ></i>
                        </v-th>
                        <th>Status</th>
                        <th>Premium</th>
                        <th>Block</th>
                        <th>View Card</th>
                        <th>Membarship</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody
                      class="infinite-list"
                      slot="body"
                      slot-scope="{ displayData }"
                      v-if="!isDataLoading"
                    >
                      <tr
                        v-for="(data, index) in displayData"
                        :key="index"
                        :id="'guest' + index"
                      >
                        <td @click="editGuest(data)">
                          <img
                            v-if="data.selfie_image != null"
                            class="rounded-circle picture-img"
                            :src="data.selfie_image"
                            alt="Avatar"
                          />
                          <span v-if="data.selfie_image != null" class="ms-1">{{
                            data.name
                          }}</span>
                          <div
                            v-if="data.selfie_image == null"
                            class="d-flex align-items-center"
                          >
                            <span
                              class="d-flex align-items-center justify-content-center avatar-md-title bg-soft bg-primary text-secondary font-20 rounded-circle picture-img"
                            >
                              {{
                                avatarGenerator(
                                  data.first_name + " " + data.last_name
                                )
                              }}
                            </span>
                            <div class="word-break-text ms-2">
                              <span> {{ data.name }}</span>
                            </div>
                          </div>
                        </td>
                        <td @click="editGuest(data)">
                          {{ data.email !== null || "" ? data.email : "-" }}
                        </td>
                        <td @click="editGuest(data)">
                          {{ data.mobile !== null || "" ? data.mobile : "-" }}
                        </td>
                        <td @click="editGuest(data)">
                          <span
                            class="badge align-items-center card-badge"
                            :class="[
                              data.doc_image_status !== 'V' &&
                              data.selfie_image_status !== 'V'
                                ? 'badge-soft-danger'
                                : 'badge-soft-success',
                            ]"
                          >
                            {{
                              data.doc_image_status !== "V" &&
                              data.selfie_image_status !== "V"
                                ? "Not Verified"
                                : "Verified"
                            }}
                          </span>
                        </td>
                        <td>
                          <div class="form-check form-switch my-1">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="data.is_premium_guest"
                              @change="
                                changePremiumStatus(data.id, {
                                  is_premium_guest: data.is_premium_guest,
                                })
                              "
                            />
                          </div>
                        </td>
                        <td>
                          <div class="form-check form-switch my-1">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="data.is_add_blacklist"
                              @change="
                                changeBlockStatus(data.id, {
                                  is_add_blacklist: data.is_add_blacklist,
                                })
                              "
                            />
                          </div>
                        </td>
                        <td @click="cardViewModal(data.id, data.name)">
                          <i
                            class="fas fa-id-card text-primary fs-5"
                            v-b-popover.hover="'View card details'"
                            id="view_card"
                          ></i>
                        </td>
                        <td @click="memberShipCard()">
                          <i class="fas fa-address-card fs-5"></i>
                        </td>
                        <td class="text-center">
                          <div class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt text-success mx-1"
                              v-b-popover.hover="'Edit recored'"
                              id="edit"
                              @click="editGuest(data)"
                            ></i>
                            <i
                              class="fas fa-user-clock text-primary mx-1"
                              v-b-popover.hover="'View card details'"
                              @click="createWakeUp(data)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="item in 13" :key="item">
                        <td class="placeholder-glow" v-for="no in 9" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isDataLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Drawer is use for open guest form -->
    <Drawer
      @close="newGuestForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openNewGuestForm">
        <GuestFrom
          :currentProps="guestProps"
          @submitted="handleSubmit"
          @cancelSubmit="newGuestForm"
          @saveAndAddNew="saveAndAddNewGuest"
        ></GuestFrom>
      </div>
    </Drawer>
    <!-- Drawer is use for open card modal -->
    <Drawer
      @close="cardModal"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="cardViewModalOpen">
        <CardDetails
          :currentProps="cardProps"
          @cardView="handleSubmit"
        ></CardDetails>
      </div>
    </Drawer>
    <!-- New Card Detail -->
    <Drawer
      @close="memberShipCard"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="memberShipCardOpen">
        <MemberShipCardDetail
          :currentProps="cardProps"
          @cardView="handleSubmit"
        ></MemberShipCardDetail>
      </div>
    </Drawer>
    <!-- filter drawer -->
    <Drawer
      @close="openGuestFilter"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="400"
      class="w-100"
    >
      <div v-if="viewFilter">
        <div class="offcanvas-body">
          <div class="offcanvas-header p-0">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              Filter <i class="fas fa-filter ms-1"> </i>
            </h5>
          </div>
          <hr />
          <div class="row">
            <div class="mb-2">
              <b-form-input
                for="text"
                placeholder="Name Search..."
                v-model="filter.name"
              ></b-form-input>
            </div>
            <div class="mb-2">
              <b-form-input
                for="email"
                placeholder="Email Search...."
                v-model="filter.email"
              ></b-form-input>
            </div>
            <div class="mb-2">
              <b-form-input
                for="text"
                placeholder="Mobile Search...."
                v-model="filter.mobile"
              ></b-form-input>
            </div>
            <div class="d-flex align-items-center">
              <button
                class="btn btn-primary"
                @click="filterData"
                :class="{ disabled: isBtnLoading }"
              >
                <i
                  v-if="isBtnLoading"
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                ></i
                >Apply
              </button>
              <button class="btn btn-primary ms-1 cursor" @click="filterReset">
                Clear Filter
              </button>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
</template>
